/* src/app/navigation/sidenav/sidenav.component.scss */
#sidenav {
  width: 320px;
}
#sidenav .sidenav-heading {
  text-align: center;
}
#sidenav .child1 > span > a {
  padding-left: 10px;
}
#sidenav .child2 > a {
  padding-left: 20px;
}
/*# sourceMappingURL=sidenav.component.css.map */
